var $a5b1f2a26d35179f$exports = {};
$a5b1f2a26d35179f$exports = {
    "collectionLabel": `Predlozi`
};


export {$a5b1f2a26d35179f$exports as default};
//# sourceMappingURL=sr-SP.mjs.map
